export default {
  name: 'CheckComponent',
  props: ['stepNumber', 'currentStep'],
  data() {
    return {
      color: 'rgb(0, 162, 150)',
      isActive: false,
      status: 'inactiveStep',
    };
  },
  methods: {
  },
};
